/**
 * i18next for the interface: `uz` (default), `ru`, `en`.
 *
 * Texts live in public/locales/<language>/common.json and are loaded over
 * HTTP; `pnpm check:i18n` fails the build when a language misses a key or the
 * code asks for one nobody defined.
 *
 * The language is the person's own choice, remembered in this browser. The
 * browser's language is not consulted: an operator on an English-language
 * laptop still gets Uzbek until they pick something else.
 */
import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import HttpBackend from "i18next-http-backend";
import { initReactI18next } from "react-i18next";

import { DEFAULT_LANGUAGE, LANGUAGES } from "./languages";

export function initI18n(): void {
  i18n.on("languageChanged", (language) => {
    document.documentElement.lang = language;
  });

  void i18n
    .use(HttpBackend)
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
      fallbackLng: DEFAULT_LANGUAGE,
      supportedLngs: [...LANGUAGES],
      ns: ["common"],
      defaultNS: "common",
      backend: { loadPath: "/locales/{{lng}}/{{ns}}.json" },
      detection: {
        order: ["localStorage"],
        caches: ["localStorage"],
        lookupLocalStorage: "hg.cc.language",
      },
      interpolation: { escapeValue: false },
      react: { useSuspense: true },
    });
}
